<template>
  <div>
    <!-- Hero Section -->
    <b-card
      class="mb-4"
      no-body
      style="background: linear-gradient(135deg, #6e44ff 0%, #8b5cf6 100%); border: none;"
    >
      <b-card-body class="text-white p-4">
        <b-row align-v="center">
          <b-col
            cols="12"
            md="8"
          >
            <h2 class="text-white mb-2">
              <feather-icon
                icon="ZapIcon"
                size="28"
                class="me-2"
              />
              TikTok Pre-Preview Center
            </h2>
            <p class="text-white-50 mb-0">
              Upload, manage, and review your creative assets for TikTok advertising campaigns
            </p>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="text-md-end mt-3 mt-md-0"
          >
            <b-button
              variant="light"
              size="lg"
              @click="$router.push({ name: 'pre-preview-upload' })"
            >
              <feather-icon
                icon="PlusIcon"
                size="18"
                class="me-1"
              />
              Upload Creative
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Stats Dashboard -->
    <b-row class="mb-4">
      <b-col
        cols="6"
        md="3"
        class="mb-3"
      >
        <b-card class="stats-card text-center border-0 shadow-sm h-100">
          <b-card-body class="p-3">
            <div class="stats-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-2">
              <feather-icon
                icon="ImageIcon"
                size="20"
                class="text-primary"
              />
            </div>
            <h4 class="text-primary mb-1">
              {{ totalCreatives || 0 }}
            </h4>
            <small class="text-muted">Total Creatives</small>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="6"
        md="3"
        class="mb-3"
      >
        <b-card class="stats-card text-center border-0 shadow-sm h-100">
          <b-card-body class="p-3">
            <div class="stats-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                size="20"
                class="text-success"
              />
            </div>
            <h4 class="text-success mb-1">
              {{ approvedCount }}
            </h4>
            <small class="text-muted">Approved</small>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="6"
        md="3"
        class="mb-3"
      >
        <b-card class="stats-card text-center border-0 shadow-sm h-100">
          <b-card-body class="p-3">
            <div class="stats-icon bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-2">
              <feather-icon
                icon="ClockIcon"
                size="20"
                class="text-warning"
              />
            </div>
            <h4 class="text-warning mb-1">
              {{ pendingCount }}
            </h4>
            <small class="text-muted">Pending Review</small>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="6"
        md="3"
        class="mb-3"
      >
        <b-card class="stats-card text-center border-0 shadow-sm h-100">
          <b-card-body class="p-3">
            <div class="stats-icon bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-2">
              <feather-icon
                icon="XCircleIcon"
                size="20"
                class="text-danger"
              />
            </div>
            <h4 class="text-danger mb-1">
              {{ rejectedCount }}
            </h4>
            <small class="text-muted">Rejected</small>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Main Action Cards -->
    <b-row class="mb-4">
      <b-col
        cols="12"
        md="4"
        class="mb-3"
      >
        <b-card
          class="action-card h-100 border-0 shadow-sm"
          @click="$router.push({ name: 'pre-preview-creatives' })"
        >
          <b-card-body class="text-center p-4">
            <div class="action-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <feather-icon
                icon="FolderIcon"
                size="32"
                class="text-primary"
              />
            </div>
            <h5 class="mb-2">
              Manage Creatives
            </h5>
            <p class="text-muted mb-3">
              Browse, preview, and manage your creative library with advanced filtering and bulk actions
            </p>
            <b-button
              variant="primary"
              size="sm"
              block
            >
              Browse Library
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="mb-3"
      >
        <b-card
          class="action-card h-100 border-0 shadow-sm"
          @click="$router.push({ name: 'pre-preview-upload' })"
        >
          <b-card-body class="text-center p-4">
            <div class="action-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <feather-icon
                icon="UploadCloudIcon"
                size="32"
                class="text-success"
              />
            </div>
            <h5 class="mb-2">
              Upload Assets
            </h5>
            <p class="text-muted mb-3">
              Upload new images, videos, and creative materials for TikTok advertising campaigns
            </p>
            <b-button
              variant="success"
              size="sm"
              block
            >
              Start Upload
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="mb-3"
      >
        <b-card
          class="action-card h-100 border-0 shadow-sm"
          @click="$router.push({ name: 'pre-preview-tasks' })"
        >
          <b-card-body class="text-center p-4">
            <div class="action-icon bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <feather-icon
                icon="ActivityIcon"
                size="32"
                class="text-info"
              />
            </div>
            <h5 class="mb-2">
              Task History
            </h5>
            <p class="text-muted mb-3">
              Monitor upload progress, review status, and track all pre-review task activities
            </p>
            <b-button
              variant="info"
              size="sm"
              block
            >
              View Tasks
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Recent Activity -->
    <b-row>
      <b-col cols="12">
        <b-card class="border-0 shadow-sm">
          <b-card-header class="bg-transparent border-0 pb-0">
            <b-row align-v="center">
              <b-col>
                <h5 class="mb-0">
                  <feather-icon
                    icon="ClockIcon"
                    size="18"
                    class="me-2 text-primary"
                  />
                  Recent Activity
                </h5>
              </b-col>
              <b-col
                v-if="creatives && creatives.length > 0"
                cols="auto"
              >
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="$router.push({ name: 'pre-preview-creatives' })"
                >
                  View All
                </b-button>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <div
              v-if="loading"
              class="text-center py-4"
            >
              <b-spinner
                variant="primary"
                label="Loading..."
              />
              <p class="text-muted mt-2 mb-0">
                Loading recent activity...
              </p>
            </div>
            <div
              v-else-if="!creatives || creatives.length === 0"
              class="text-center py-5"
            >
              <feather-icon
                icon="InboxIcon"
                size="48"
                class="text-muted mb-3"
              />
              <h6 class="text-muted mb-2">
                No recent activity
              </h6>
              <p class="text-muted small mb-4">
                Upload your first creative to get started with TikTok pre-review
              </p>
              <b-button
                variant="primary"
                @click="$router.push({ name: 'pre-preview-upload' })"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="16"
                  class="me-1"
                />
                Upload Creative
              </b-button>
            </div>
            <b-table
              v-else
              :items="creatives"
              :fields="tableFields"
              responsive
              borderless
              hover
              class="mb-0"
            >
              <template #cell(preview)="{ item }">
                <div class="d-flex align-items-center">
                  <div class="creative-mini-preview me-2">
                    <feather-icon
                      :icon="isVideoItem(item) ? 'PlayCircleIcon' : 'ImageIcon'"
                      size="20"
                      :class="isVideoItem(item) ? 'text-purple' : 'text-primary'"
                    />
                  </div>
                </div>
              </template>
              <template #cell(name)="{ item }">
                <div>
                  <span class="fw-semibold">{{ item.filename || item.name || 'Untitled' }}</span>
                  <br>
                  <small class="text-muted text-capitalize">
                    {{ isVideoItem(item) ? 'Video' : 'Image' }}
                  </small>
                </div>
              </template>
              <template #cell(status)="{ item }">
                <b-badge
                  :variant="getStatusVariant(item)"
                  class="text-capitalize"
                >
                  {{ getStatusText(item) }}
                </b-badge>
              </template>
              <template #cell(created_at)="{ item }">
                <small class="text-muted">
                  {{ formatDate(item.createdAt || item.created_at || item.uploadDate) }}
                </small>
              </template>
              <template #cell(actions)="">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="$router.push({ name: 'pre-preview-creatives' })"
                >
                  <feather-icon
                    icon="EyeIcon"
                    size="14"
                  />
                </b-button>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BTable,
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PrePreviewIndex',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BSpinner,
  },
  data() {
    return {
      tableFields: [
        {
          key: 'preview', label: '', thClass: 'text-center', tdClass: 'text-center',
        },
        { key: 'name', label: 'Creative' },
        {
          key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center',
        },
        {
          key: 'created_at', label: 'Uploaded', thClass: 'text-center', tdClass: 'text-center',
        },
        {
          key: 'actions', label: '', thClass: 'text-center', tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapState('creativeUpload', [
      'creativesList',
      'creativesTotal',
      'loading',
    ]),
    creatives() {
      // Return first 5 recent creatives for dashboard
      return this.creativesList ? this.creativesList.slice(0, 5) : []
    },
    totalCreatives() {
      return this.creativesTotal || 0
    },
    approvedCount() {
      if (!this.creativesList) return 0
      return this.creativesList.filter(item => item.preReviewStatus === 'approved'
        || item.pre_review_status === 'approved'
        || (item.metadata?.pre_review_result_list
         && item.metadata.pre_review_result_list.some(r => r.pre_review_status === 'approved'))).length
    },
    pendingCount() {
      if (!this.creativesList) return 0
      return this.creativesList.filter(item => item.preReviewStatus === 'pending'
        || item.pre_review_status === 'pending'
        || item.status === 'processing'
        || item.status === 'uploaded'
        || (item.metadata?.pre_review_result_list
         && item.metadata.pre_review_result_list.some(r => r.pre_review_status === 'pending'))).length
    },
    rejectedCount() {
      if (!this.creativesList) return 0
      return this.creativesList.filter(item => item.preReviewStatus === 'rejected'
        || item.pre_review_status === 'rejected'
        || item.status === 'failed'
        || (item.metadata?.pre_review_result_list
         && item.metadata.pre_review_result_list.some(r => r.pre_review_status === 'rejected'))).length
    },
  },
  async mounted() {
    await this.fetchRecentCreatives()
  },
  methods: {
    ...mapActions('creativeUpload', [
      'fetchCreatives',
      'setPageSize',
    ]),
    async fetchRecentCreatives() {
      try {
        // Set small page size for dashboard overview
        await this.setPageSize(10)
        await this.fetchCreatives()
      } catch (error) {
        // Error handled silently - dashboard will show empty state
      }
    },
    isVideoItem(item) {
      if (!item) return false

      // Check explicit type field
      if (item.type === 'video') return true

      // Check mime type
      if (item.mime_type && item.mime_type.toLowerCase().startsWith('video/')) return true

      // Check filename extensions
      const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.flv', '.wmv', '.mpeg']
      const filename = item.filename || item.original_filename || ''

      return videoExtensions.some(ext => filename.toLowerCase().endsWith(ext))
    },
    getStatusVariant(item) {
      if (!item) return 'secondary'

      // Check pre-review status first
      const preReviewStatus = item.preReviewStatus || item.pre_review_status
      if (preReviewStatus) {
        const statusVariants = {
          approved: 'success',
          rejected: 'danger',
          pending: 'warning',
          unavailable: 'secondary',
        }
        return statusVariants[preReviewStatus.toLowerCase()] || 'secondary'
      }

      // Fallback to upload status
      const uploadVariants = {
        completed: 'primary',
        ready: 'primary',
        processing: 'warning',
        uploaded: 'info',
        failed: 'danger',
      }

      return uploadVariants[item.status?.toLowerCase()] || 'secondary'
    },
    getStatusText(item) {
      if (!item) return 'Unknown'

      // Check pre-review status first
      const preReviewStatus = item.preReviewStatus || item.pre_review_status
      if (preReviewStatus && preReviewStatus !== 'undefined') {
        const statusMap = {
          approved: 'Approved',
          rejected: 'Rejected',
          pending: 'Reviewing',
          unavailable: 'Unavailable',
        }
        return statusMap[preReviewStatus.toLowerCase()] || preReviewStatus
      }

      // Fallback to upload status
      const uploadMap = {
        completed: 'Ready',
        ready: 'Ready',
        processing: 'Processing',
        uploaded: 'Uploaded',
        failed: 'Failed',
      }

      return uploadMap[item.status?.toLowerCase()] || 'Unknown'
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      try {
        const date = new Date(dateString)
        const now = new Date()
        const diffTime = Math.abs(now - date)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays === 1) return 'Today'
        if (diffDays === 2) return 'Yesterday'
        if (diffDays <= 7) return `${diffDays - 1} days ago`

        return date.toLocaleDateString()
      } catch (error) {
        return 'N/A'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
